import _extends from "@babel/runtime/helpers/esm/extends";
var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Components as TooltipComponents } from './tooltip.style';
function Tooltip(_a) {
  var {
      className = 'tooltip',
      content,
      position = 'top',
      children,
      width = 'auto',
      appearance = 'default',
      fit = 'medium',
      zIndex = 9999,
      disabled = false
    } = _a,
    rest = __rest(_a, ["className", "content", "position", "children", "width", "appearance", "fit", "zIndex", "disabled"]);
  const theme = appearance && appearance === 'default' ? 'light-border' : '';
  return _jsx(TooltipComponents.Tooltip, _extends({
    className: className,
    content: content,
    placement: position,
    maxWidth: width,
    theme: theme,
    "$fit": fit,
    zIndex: zIndex,
    disabled: disabled || typeof content == 'string' && !content.trim()
  }, rest, {
    children: children
  }));
}
export default Tooltip;